import { pascalCaseSegment } from './pascalCaseSegment'

export const pascalCaseFull = (input: string): string =>
  input
    .split(/[-_./\\]+/)
    .filter(Boolean)
    .map(pascalCaseSegment)
    .join('')
